// extracted by mini-css-extract-plugin
export default {"box":"notfound_box__rH4pR"};